import { EMPTY_OBJECT } from '../../../../constants/common'
import { useCalendarGridItemHandlers } from '../../CalendarGrid.hooks'
import { CalendarGridDayPopoverCompactRow } from '../CalendarGridDayPopoverCompactRow'
import { CalendarGridDayPopoverRowSubItems } from '../CalendarGridDayPopoverRow'

function CalendarGridDayPopoverCompactItem({
  item = EMPTY_OBJECT,
  onClickItem,
  ...rowProps
}) {
  const { getHandleClickSubItem } = useCalendarGridItemHandlers({
    item,
    onClickItem,
  })

  const { popover: { subItems } = EMPTY_OBJECT } = item

  return (
    <>
      <CalendarGridDayPopoverCompactRow
        {...rowProps}
        item={item}
        onClickItem={onClickItem}
      />
      {subItems ? (
        <CalendarGridDayPopoverRowSubItems
          getHandleClickSubItem={getHandleClickSubItem}
          subItems={subItems}
        />
      ) : null}
    </>
  )
}

export default CalendarGridDayPopoverCompactItem
